// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__26buJ","productName":"Table_productName__1febU"};